import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PatientTasksScreen } from 'screens/patient';

export default withPermissions(PatientTasksScreen, [GroupSecurity.TaskRead]);
